import { isServerSide } from './isServerSide';
import { isZillowURL } from './isZillowURL';

/**
 * Returns true if the Location hostname is a Zillow domain, or if the pathname is a path that's used
 * for serving the Zillow domain experiences. Returns false if run on the server side.
 */
export const isClientOriginOrPathZillow = (): boolean =>
    !isServerSide() && (isZillowURL(window.location.hostname) || isZillowURL(window.location.pathname));
